module.exports = __webpack_public_path__ + "static/media/multiple-choice-icon.01e0bef6.svg";